import script from "./MentionTextArea.vue?vue&type=script&setup=true&lang=js"
export * from "./MentionTextArea.vue?vue&type=script&setup=true&lang=js"

import "./MentionTextArea.vue?vue&type=style&index=0&id=25a3f7cf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a3f7cf"]])

export default __exports__